export default "__VITE_ASSET__CmoMN4mR__"